import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

interface SpinProps {
    spinning?: boolean;
    tip?: React.ReactNode;
    size?: number;
    children?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
}

const Spin = ({ spinning = true, tip, size = 20, children, style, className }: SpinProps) => {
    if (children === undefined) {
        return spinning ? (
            <CircularProgress size={size} style={style} className={className} />
        ) : null;
    }

    return (
        <Box sx={{ position: "relative" }} style={style} className={className}>
            {spinning && (
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                        bgcolor: "rgba(255, 255, 255, 0.6)",
                        zIndex: 10,
                    }}
                >
                    <CircularProgress />
                    {tip != null && (
                        <Typography variant="body2" color="primary">
                            {tip}
                        </Typography>
                    )}
                </Box>
            )}
            {children}
        </Box>
    );
};

export default Spin;
